import React from 'react';
import EntryClosedNotice from '../EntryClosedNotice';
import RaidLogoAnimation from '../RaidLogoAnimation';
import ScheduleBanner from '../ScheduleBanner';
import { useRaidFvBootContext } from '../RaidFvBootGate';
import { FIRST_VIEW } from '../content';
import styles from './FirstView.module.css';

const CORPORATE_LOGO_SRC = `${process.env.PUBLIC_URL}/assets/images/jp_jtc_logo_white.svg`;
const CORPORATE_ICON_SRC = `${process.env.PUBLIC_URL}/assets/images/raid2026/logo_jtc_icon_white.svg`;

// ファーストビュー。演出付き RAID ロゴを主役にし、後続要素を順番に出す。
export default function FirstView() {
  const { booting } = useRaidFvBootContext();

  const handleScrollDown = () => {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    window.scrollBy({
      top: window.innerHeight,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  };

  return (
    <section
      className={`relative flex min-h-screen flex-col items-center justify-center px-6 pb-16 pt-6 text-center ${booting ? styles.frozenReveals : ''}`}
    >
      <a
        href="/"
        className={`${styles.siteLogoLink} ${styles.reveal} ${styles.siteLogoReveal}`}
        aria-label="コーポレートサイトへ戻る"
      >
        <picture>
          <source media="(max-width: 640px)" srcSet={CORPORATE_ICON_SRC} />
          <img
            src={CORPORATE_LOGO_SRC}
            alt="日本トレカセンター"
            className={styles.siteLogo}
            loading="eager"
          />
        </picture>
      </a>
      <div
        className={`${styles.heroContent} -translate-y-6 flex w-full max-w-2xl flex-col items-center sm:-translate-y-6 sm:max-w-3xl`}
      >
        <RaidLogoAnimation
          ariaLabel={`${FIRST_VIEW.brand} ${FIRST_VIEW.subtitle}`}
        />
        <div className={`${styles.reveal} ${styles.schedule}`}>
          <ScheduleBanner />
        </div>
        <p className={`${styles.reveal} ${styles.leadText}`}>
          日本トレカセンター サマーインターンシップ2026 特設サイト
        </p>
        <EntryClosedNotice
          variant="hero"
          className={`${styles.reveal} ${styles.notice}`}
        />
      </div>
      <button
        type="button"
        className={`${styles.reveal} ${styles.scrollCue}`}
        onClick={handleScrollDown}
        aria-label="次のセクションへスクロール"
      >
        <span className={styles.scrollText}>SCROLL DOWN</span>
        <span className={styles.scrollLine} />
      </button>
    </section>
  );
}
